declare var ko: any;

export class DragAndDropHandler {
    /**
     * This function allows to apply drag and drop and reordering functionality on any observable array
     *
     * @param element - The current element where the foreach binding is applied ($element)
     * @param currentObservableArray - The current observable Array
     * @param childrenSelector - The selector where the drag and drop event will be applied
     */
    public static handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        let dragSrcEl = null;

        const elementNodeList = element.querySelectorAll(`${childrenSelector}`);

        // no elements, nothing to do
        if (!elementNodeList) {
            return;
        }

        function handleDragStart(e) {

            dragSrcEl = this;
            e.dataTransfer.effectAllowed = 'move';

            return false
        }

        function handleDragEnter() {
        }

        function handleDrag(e) {
            e.target.classList.add("active")
        }

        function handleDragOver(e) {
            e.preventDefault()

            let observableToArray = currentObservableArray()

            let dataDragSrcEl = ko.dataFor(dragSrcEl)
            let dataDragDestEl = ko.dataFor(this)

            const positionDragSrcEl = observableToArray.indexOf(dataDragSrcEl)
            const positionDragDestEl = observableToArray.indexOf(dataDragDestEl)

            if(positionDragSrcEl < positionDragDestEl){
                this.classList.add('after')
            }

            if(positionDragSrcEl > positionDragDestEl){
                this.classList.add('before')
            }

            e.dataTransfer.dropEffect = "move"
            return false
        }

        function handleDragLeave() {
            // dragSrcEl.classList.remove('active')
            this.classList.remove('before');
            this.classList.remove('after');
        }

        function handleDrop(e) {

            e.preventDefault();
            e.stopPropagation()

            let dragDestEl = this

            let observableToArray = currentObservableArray()

            let dataDragSrcEl = ko.dataFor(dragSrcEl)
            let dataDragDestEl = ko.dataFor(dragDestEl)

            const positionDragSrcEl = observableToArray.indexOf(dataDragSrcEl)
            const positionDragDestEl = observableToArray.indexOf(dataDragDestEl)

            if(dragSrcEl != dragDestEl){
                observableToArray.splice(positionDragDestEl,0, observableToArray.splice(positionDragSrcEl, 1)[0])
                currentObservableArray(observableToArray)
            }

            this.classList.remove('before');
            this.classList.remove('after');

            return false
        }

        function handleDragEnd(e) {
            e.target.classList.remove('active')
        }

        const dragElements = element.querySelectorAll(`${childrenSelector}.drag-element`);

        const resetDragElements = dragElements.length !== elementNodeList.length;

        elementNodeList.forEach(function (elem) {
            // reset them each time the list is refreshed.
            // seeing problems with lists that start out as empty, and this sorted it out.
            if(resetDragElements && elem.classList.contains('drag-element')){
                elem.draggable = false
                elem.classList.remove('drag-element')
                elem.removeEventListener('dragstart', handleDragStart);
                elem.removeEventListener('dragenter', handleDragEnter)
                elem.removeEventListener('drag', handleDrag)
                elem.removeEventListener('dragover', handleDragOver);
                elem.removeEventListener('dragleave', handleDragLeave);
                elem.removeEventListener('drop', handleDrop);
                elem.removeEventListener('dragend', handleDragEnd);
            }

            if (!elem.classList.contains('drag-element')) {
                elem.draggable = true
                elem.classList.add('drag-element')
                elem.addEventListener('dragstart', handleDragStart);
                elem.addEventListener('dragenter', handleDragEnter)
                elem.addEventListener('drag', handleDrag)
                elem.addEventListener('dragover', handleDragOver);
                elem.addEventListener('dragleave', handleDragLeave);
                elem.addEventListener('drop', handleDrop);
                elem.addEventListener('dragend', handleDragEnd);
            }
        })
    }
}

/**
 * Drag and drop and reordering costum binding
 *
 * How to use:
 *
 * <ul data-bind=" foreach: myObservableArray, dragAndDrop: { observableArray: myObservableArray, childrenSelector: '.my-class' }">
 *      <li class="my-class" data-bind=" text: name"></li>
 * </ul>
 *
 * This approach is simple and prevent us to expose the handleDragAndDrop function
 *
 */
ko.bindingHandlers.dragAndDrop = {
    init(element, valueAccessor) {
        ko.bindingEvent.subscribe(element, 'childrenComplete', () => {
            const { observableArray, childrenSelector } = ko.unwrap(valueAccessor());
            DragAndDropHandler.handleDragAndDrop(element, observableArray, childrenSelector);
        });
    }
};



// WEBPACK FOOTER //
// ./js/utils/DragAndDropHandler.ts